import { PersonSmartSuggestModel, PersonSmartSuggestionModel } from ".";
export interface IPersonSmartSearchParameterModel {
    InputEntries: PersonSmartSuggestModel[];
    RegionEntries: PersonSmartSuggestionModel[];
    Input: string;
    FieldId: number;
    FieldCategory: string;
    StatusIds:number[];
    ManagerIds:number[];
    SiteIds:number[];
    Ids:number[];
    Category1Ids: number[];
    IsDeleted?: boolean;
    OnStringFields?: any[];
    ViewTypes?: number[];
}
export class PersonSmartSearchParameterModel {
    InputEntries: PersonSmartSuggestModel[];
    RegionEntries: PersonSmartSuggestionModel[];
    Input: string;
    FieldId: number;
    FieldCategory: string;
    StatusIds:number[];
    ManagerIds:number[];
    SiteIds:number[];
    Ids:number[];
    Category1Ids: number[];
    IsDeleted?: boolean = false;
    OnStringFields?: any[];
    ViewTypes?: number[];
    /**
     *
     */
    constructor(option?: IPersonSmartSearchParameterModel) {
        if (option != null) {
            // this.InputEntries = option.InputEntries || [];
            // this.RegionEntries = option.RegionEntries || [];
            // this.StatusIds = option.StatusIds || [];
            // this.ManagerIds = option.ManagerIds || [];
            // this.SiteIds = option.SiteIds || [];
            // this.Ids = option.Ids || [];
            // this.Category1Ids = option.Category1Ids || [];
            Object.keys(option).forEach((key) => {
                this[key] = option[key]
            })
        }
    }
    
    record(value: any, key: string) {
        this[key] = value
    }
}